export enum ProfileTypeEnum {
  Store = 'Store',
  User = 'User',
}
